import { render, staticRenderFns } from "./gdpr-details.vue?vue&type=template&id=4195c86c&lang=pug&"
import script from "./gdpr-details.vue?vue&type=script&lang=js&"
export * from "./gdpr-details.vue?vue&type=script&lang=js&"
import style0 from "./gdpr-details.vue?vue&type=style&index=0&id=4195c86c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports